const confirmPuzzle = function () {

    let size = 3;
    let shuffleCount = 3;
    let numberOfTiles = size ** 2;
    let highlighted = numberOfTiles;

    let form = document.querySelector('.puzzle-confirm form');
    let controls = document.querySelector('.controls .control');
    let confirm = document.querySelector('.controls .confirm');
    let puzzleContainer = document.getElementById('puzzleContainer');
    let puzzleWrapper = document.getElementById('puzzleWrapper');
    let shuffled = false;

    const RIGHT_ARROW = 39;
    const LEFT_ARROW = 37;
    const UP_ARROW = 40;
    const DOWN_ARROW = 38;

    window.addEventListener('keydown', function (event) {
        switch (event.keyCode) {
            case RIGHT_ARROW:
                switchTiles(highlighted + 1);
                break;
            case LEFT_ARROW:
                switchTiles(highlighted - 1);
                break;
            case UP_ARROW:
                switchTiles(highlighted + size);
                break;
            case DOWN_ARROW:
                switchTiles(highlighted - size);
                break;
        }
    });

    form.addEventListener('submit', function (event) {
        event.preventDefault();
        startConfirmPuzzle();
    });

    controls.addEventListener('click', function (event) {
        let action = event.currentTarget.dataset.action;
        switch (action) {
            case 'restart':
                shuffled = false;
                startConfirmPuzzle();
                break;
        }
    });

    function init() {}

    function startConfirmPuzzle() {
        puzzleContainer.innerHTML = "";
        for (let b = 1; b <= numberOfTiles; b++) {

            const tile = document.createElement('div');
            const tileImage = document.createElement("img");
            tileImage.src = `/assets/media/puzzle/piece${b}.png`;
            tile.appendChild(tileImage);

            tile.id = `p${b}`;
            tile.setAttribute('index', b);
            tile.dataset.location = b;

            tile.classList.add('piece');
            tile.addEventListener('click', function () {
                switchTiles(parseInt(this.getAttribute('index')));
            });
            puzzleContainer.append(tile);
        }
        const selectedTileId = 'p' + highlighted;
        const selectedTile = document.getElementById(selectedTileId);
        selectedTile.classList.add("selected");

        shuffle(shuffleCount);

        $('#contact_form_wrapper').fadeOut(200, function () {
            $(puzzleWrapper).fadeIn(200, function () {
                puzzleWrapper.classList.add("ready");
            });
        });
    }

    function shuffle(totalShuffles) {
        for (let i = 0; i < totalShuffles; i++) {
            const x = Math.floor(Math.random() * 4);
            let direction = 0;

            switch (x) {
                case 0:
                    direction = highlighted + 1;
                    break;
                case 1:
                    direction = highlighted - 1;
                    break;
                case 2:
                    direction = highlighted + size;
                    break;
                case 3:
                    direction = highlighted - size;
                    break;
            }

            switchTiles(direction);
        }

        if (checkPuzzleCompleted()) {
            shuffle(shuffleCount);
        }

        shuffled = true;
    }

    function switchTiles(clicked) {
        if (clicked < 1 || clicked > (numberOfTiles)) {
            return;
        }

        if ((clicked === highlighted + 1 && clicked % size !== 1) ||  // Swap right
            (clicked === highlighted - 1 && clicked % size !== 0) ||  // Swap left
            clicked === highlighted + size ||                         // Swap up
            clicked === highlighted - size) {                         // Swap down
            setActive(clicked);
        }

        if (shuffled) {
            if (checkPuzzleCompleted()) {
                puzzleContainer.style.borderColor = '#a6ce39';
                controls.style.display = 'none';
                confirm.style.setProperty("display", "block", "important");

                form.submit();
            }
        }
    }

    function checkPuzzleCompleted() {
        let currentTile;
        let currentTileIndex;
        let currentTileValue;

        for (let b = 1; b <= numberOfTiles; b++) {
            currentTile = document.getElementById(`p${b}`);
            currentTileIndex = currentTile.getAttribute('index');
            currentTileValue = currentTile.dataset.location;

            if (parseInt(currentTileIndex) !== parseInt(currentTileValue)) {
                return false;
            }
        }
        return true;
    }

    function setActive(index) {
        const currentTile = document.getElementById(`p${highlighted}`);
        const newTile = document.getElementById(`p${index}`);

        const currentTileImg = currentTile.querySelector('img');
        const newTileImg = newTile.querySelector('img');

        const currentTileLocation = currentTile.dataset.location;
        const newTileLocation = newTile.dataset.location;

        currentTile.classList.remove('selected');

        currentTile.dataset.location = newTileLocation;
        currentTileImg.src = `/assets/media/puzzle/piece${newTileLocation}.png`;

        newTile.dataset.location = currentTileLocation;
        newTileImg.src = `/assets/media/puzzle/piece${index}.png`;

        newTile.classList.add('selected');
        highlighted = index;
    }

    return {
        init: function () {
            init();
        }
    };
}();

jQuery(document).ready(function () {
    confirmPuzzle.init();
});